import { render } from "./UkrainianDashboard.vue?vue&type=template&id=1d31b302"
import script from "./UkrainianDashboard.vue?vue&type=script&lang=js"
export * from "./UkrainianDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__